// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Xs-z","tooltipWrapper":"Ys-z","icon":"Zs-z","tooltip":"_s-z","content":"at-z"};